export interface VehicleLocationDto {
  latitude?: number;
  longitude?: number;
  direction?: number;
  altitude?: number;
  gpsLock?: number;
  staleGpsIndicator?: number;
  speed?: number;
  tripMeter?: number;
  driveMode?: number;
  batteryPowerLevel?: number;
  energyUsed?: number;
  energyRecovered?: number;
  inverterMotorPower?: number;
  inverterEfficiency?: number;
  gpsModeIndicator?: string;
  gpsSatelliteCount?: number;
  gpsHdop?: number;
  gpsSpeed?: number;
  gpsSignalQuality?: number;
  date?: string; // NOTE not yet implemented on backend
}
